module.exports = __webpack_public_path__ + "img/95ne.8ad7c698.svg";